module.exports = __webpack_public_path__ + "img/es-ga.es-ga33cb6bd.svg";